import { RouteObject } from "react-router-dom";
import pathRoutes from "../../../routes/pathRoutes";
import Authenticated from "../../../utils/Authenticated";
import { MODES_OPTIONS } from "../../../types/generics.types";
import ReportListLayout from "../components/layouts/layout";
import ReportList from "../report";
import ReportEditLayout from "../components/layouts/layoutEdit";
import EditReport from "../editReport";
import { PrivateRoutes } from "@app/utils/PrivateRoutes";
import { RolesTypes } from "@app/pages/users/utils/helpers";

const routesReport: RouteObject = {
  path: pathRoutes.ADMIN_INFORMES,
  element: (
    <Authenticated>
      <ReportListLayout />
    </Authenticated>
  ),
  children: [
    {
      path: "",
      index: true,
      element: (
        <Authenticated>
          <ReportList />
        </Authenticated>
      ),
    },
    {
      path: "nuevo",
      element: (
        <PrivateRoutes permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}>
          <ReportEditLayout />
        </PrivateRoutes>
      ),
      children: [
        {
          index: true,
          element: (
            <Authenticated>
              <EditReport mode={MODES_OPTIONS.NEW} />
            </Authenticated>
          ),
        },
      ],
    },
    {
      path: "editar/:idReport",
      element: (
        <PrivateRoutes permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}>
          <ReportEditLayout />
        </PrivateRoutes>
      ),
      children: [
        {
          index: true,
          element: (
            <Authenticated>
              <EditReport mode={MODES_OPTIONS.EDIT} />
            </Authenticated>
          ),
        },
      ],
    },
    {
      path: "copiar/:idReport",
      element: (
        <PrivateRoutes permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}>
          <ReportEditLayout />
        </PrivateRoutes>
      ),
      children: [
        {
          index: true,
          element: (
            <Authenticated>
              <EditReport mode={MODES_OPTIONS.COPY} />
            </Authenticated>
          ),
        },
      ],
    },
    {
      path: "ver/:idReport",
      element: <ReportEditLayout />,
      children: [
        {
          index: true,
          element: (
            <Authenticated>
              <EditReport mode={MODES_OPTIONS.VIEW} />
            </Authenticated>
          ),
        },
      ],
    },
  ],
};

export default routesReport;
